import { PortalRouteParams, State, ExtraUserInfo } from "../portal_client";
import { AppState, LoginState } from "../../components/portal/state";
import { state } from "../../components/portal/login";
import { stateZero } from "./state_zero";
import { none } from "widgets-for-react";

export let application_zero = (initial_login_state: LoginState<State, ExtraUserInfo>) : AppState<State, PortalRouteParams, ExtraUserInfo> => 
    state<State, PortalRouteParams, ExtraUserInfo>(() => stateZero, initial_login_state, { kind: "404" }, "standard", none())